<div class="copy-from-share-simple">
    <div slot="title" class="copy-from-switch">
        <h2 class="card-title">{{i18nLabel.cifsShareTitle}}</h2>
        <n-switch id="copy-from-cifs-s" [(ngModel)]="switch" (onChange)="onSwitchChange($event)" class="mb-8">
        </n-switch>
    </div>

    <form *ngIf="switch" [errorMessage]="errorMessage" [formGroup]="vm" [simpleMode]="true">
        <!-- 创建模式 -->
        <n-form-item [label]="i18nLabel.permissionTitle" [required]="true" class="create-style">
            <n-radio-group id="copy-from-cifs-share_style" formControlName="CIFScreateStyle"
                (onChange)="onPermissionCreateStyleChange($event)">
                <n-radio id="copy-from-cifs-share_copyFrom"
                    [value]="CreateStyleE.All">
                    {{i18nLabel.allUserLab}}
                    <n-help-icon [content]="this.entry === FileSystemEntryE.AuditLog ?
                                                            i18nLabel.allUserLabReadOnlyTip : i18nLabel.allUserLabTip">
                    </n-help-icon>
                </n-radio>
                <n-radio id="copy-from-cifs-share_new"
                    [value]="CreateStyleE.New">
                    {{i18nLabel.manuUserLab}}
                    <n-help-icon [content]="i18nLabel.manuUserLabTip">
                    </n-help-icon>
                </n-radio>
            </n-radio-group>
        </n-form-item>

        <!-- CIFS权限配置 -->
        <n-form-item labelHide="true" *ngIf="vm.value.CIFScreateStyle === CreateStyleE.New" class="mt-16">
            <app-front-table-client-cifs-share
                [supportSmartGui]="supportSmartGui"
                [isCopyFrom]='isCopyFrom'
                [(tableData)]="userList"
                [selectFs]="fileSystem"
                [vstoreId]="vstoreId"
                [vstoreName]="vstoreName"
                [entry]="entry"
                [supportTableEdit]="true"
                (tableDataChange)="onTableClientCifsChange($event)">
            </app-front-table-client-cifs-share>
        </n-form-item>
    </form>
</div>
